export default __webpack_public_path__ + "static/media/fax.60d7a637.svg";